import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { getRelatedCronosEvmChain } from '@cronos-app/sdk';
import { getSDK } from '@ui/utils/getSDK';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getCROToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.CRO,
    symbol: 'CRO',
    addressL1: sdks.L1.getContractAddress('WCRO'),
    addressL2: sdks.L2.getContractAddress('WCRO'),
    addressCronosEvm: getSDK(
      getRelatedCronosEvmChain(desiredNetwork),
    ).getContractAddress('WCRO'),
    // FIXME: should be 18 in cronos/cronoszk
    decimals: 8,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/cro.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="cro"
        {...props}
      />
    ),
  };
};
